import { render, staticRenderFns } from "./CustomResource.vue?vue&type=template&id=17a1ad7c&scoped=true"
import script from "./CustomResource.vue?vue&type=script&lang=js"
export * from "./CustomResource.vue?vue&type=script&lang=js"
import style0 from "./CustomResource.vue?vue&type=style&index=0&id=17a1ad7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a1ad7c",
  null
  
)

export default component.exports